<!--
 * @Author: wangyueqi
 * @Date: 2024-10-22 09:01:21
 * @LastEditors: wangyueqi
 * @LastEditTime: 2024-11-01 13:40:50
 * @Description: 
-->
<template>
  <div ref="careEchart" style="width: 100%; height: 100%"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props:['sosTypeData'],
  mounted() {
    var myChart = echarts.init(this.$refs.careEchart);
    myChart.setOption({
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)",
      },
      legend: {
        orient: "vertical",
        right: "5%",
        top: "5%",
        textStyle: {
          color: "#fff",
        },
      },
      series: [
        {
          name: "",
          type: "pie",
          radius: "48%",
          center: ["50%", "50%"],
          avoidLabelOverlap: false,
          color: ["#37a2da", "#ffdb5c", "#9A60B4"],
          label: {
            show: true,
            color: "#6dd6f8",
            fontSize: 16,
            formatter: "{b}\n{d}%",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "20",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: true,
          },
          data:this.sosTypeData,
        },
      ],
    });
  },
};
</script>

<style>
</style>